import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import DataTable from '../../../components/DataTable';
import EditModal from '../../../components/EditModal';
import DownClickablePopup from '../../../components/DownClickablePopup';
import { prayerTimeSchema } from '../../../formData/prayerTimeSchema';
import { showSuccess } from '../../../components/showSuccess';

const initialData = [
  { id: '1', title: 'Lorem ipsum dolor sit.', time: '08:00am', day: 'Friday' },
  { id: '2', title: 'Consectetur adipiscing.', time: '01:15pm', day: 'Saturday' },
  { id: '3', title: 'Sed do eiusmod.', time: '05:30pm', day: 'Sunday' },
  // … up to 25 rows …
];

export default function PrayerTimesPage() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState('');
  const [filterOpen, setFilterOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);

  const filtered = data.filter(
    r =>
      r.title.toLowerCase().includes(search.toLowerCase()) ||
      r.day.toLowerCase().includes(search.toLowerCase())
  );

  const columns = [
    { key: 'title', title: 'TITLE' },
    { key: 'time', title: 'TIME OF PRAYER' },
    { key: 'day', title: 'DAY OF PRAYER' },
    {
      key: 'actions',
      title: 'ACTION',
      render: (_, row) => (
        <div style={{ display: 'flex', gap: 8 }}>
          <button style={styles.actionBtn} onClick={() => openEdit(row)} title="Edit">
            <span className="material-icons">edit</span>
          </button>
          <button style={styles.actionBtn} title="View">
            <span className="material-icons">visibility</span>
          </button>
          <button style={styles.actionBtn} title="Copy">
            <span className="material-icons">content_copy</span>
          </button>
          <button style={styles.actionBtn} onClick={() => removeRow(row.id)} title="Delete">
            <span className="material-icons" style={{ color: '#e53e3e' }}>delete</span>
          </button>
        </div>
      )
    }
  ];

  function openEdit(row) {
    setEditRow(row);
    setModalOpen(true);
  }

  async function onSave(action, formData) {
    if (action === 'cancel') {
      setModalOpen(false);
    }
    if (action === 'save') {
      // either update or add new
      setData(d => {
        if (editRow) {
          return d.map(r => (r.id === editRow.id ? { ...r, ...formData } : r));
        } else {
          const id = String(d.length + 1);
          return [...d, { id, ...formData }];
        }
      });
      setModalOpen(false);
      await showSuccess('Prayer time saved!');
    }
  }

  function removeRow(id) {
    if (window.confirm('Delete this prayer time?')) {
      setData(d => d.filter(r => r.id !== id));
    }
  }

  return (
    <>
      <div style={styles.container}>
        <div style={styles.toolbar}>
          <div>
            <h1 style={styles.title}>Prayer Times</h1>
          </div>
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
          }}>
            <button style={styles.addBtn} onClick={() => openEdit(null)}>
              + Add Prayer
            </button>

            <div style={styles.searchWrapper}>
              <span className="material-icons" style={styles.searchIcon}>search</span>
              <input
                type="text"
                placeholder="Search..."
                value={search}
                onChange={e => setSearch(e.target.value)}
                style={styles.searchInput}
              />
            </div>

            <DownClickablePopup
              popUpTitle="Filter"
              filters={
                <div style={{ padding: 12 }}>
                  <label>
                    Day:
                    <select
                      onChange={e => {
                        const day = e.target.value;
                        setSearch(day);
                      }}
                      style={{ marginLeft: 8 }}
                    >
                      <option value="">All</option>
                      <option>Friday</option>
                      <option>Saturday</option>
                      <option>Sunday</option>
                    </select>
                  </label>
                </div>
              }
            >
              <button style={styles.iconBtn}>
                <span className="material-icons">filter_list</span>
              </button>
            </DownClickablePopup>

            <button style={styles.iconBtn}>
              <span className="material-icons">file_download</span>
            </button>
            <button style={styles.iconBtn}>
              <span className="material-icons">print</span>
            </button>

          </div>
        </div>

        <DataTable data={filtered} columns={columns} rowKey="id" />

        <EditModal
          visible={modalOpen}
          schema={prayerTimeSchema}
          initialData={editRow || {}}
          onClose={() => setModalOpen(false)}
          onSubmit={onSave}
        />
      </div>
    </>
  );
}

const styles = {
  container: {
    margin: '0 auto',
    color: '#333'
  },
  title: {
    fontSize: 24,
    marginTop: 0,
    color: '#4a5568'
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    marginBottom: 16,
    justifyContent: 'space-between'
  },
  addBtn: {
    background: '#7c4dff',
    color: '#fff',
    border: 'none',
    padding: '8px 16px',
    borderRadius: 4,
    cursor: 'pointer',
  },
  searchWrapper: { position: 'relative', width: 200 },
  searchIcon: { position: 'absolute', top: 8, left: 8, color: '#999' },
  searchInput: {
    width: '100%',
    padding: '8px 8px 8px 32px',
    borderRadius: 4,
    border: '1px solid #ccc',
  },
  iconBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    fontSize: 20,
    padding: 4,
  },
  actionBtn: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    color: '#555',
    marginRight: 8,
    fontSize: 18
  }
};
